module.exports = __webpack_public_path__ + "562c9594e4f35758990cb346691979a3.png";